import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatPrevisaoVendaStatus',
})
export class FormatPrevisaoVendaStatusPipe implements PipeTransform {
  transform(text: string | null | undefined): string {
    if(!text){
      return 'Todos';
    }

    if(text === 'P'){
      return 'Completa';
    }

    if(text === 'C'){
      return 'Incompleta';
    }

    return text;
  }
}
